import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { Row, Section } from 'components/ui/table/elements';
import PrimaryButton from 'components/button/PrimaryButton';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui';
import utils from 'helpers/utils';
import CreateButton from 'components/button/CreateButton';
import AccountSearchUserLimit from 'components/notifications/AccountSearchUserLimit';
import Notification from 'components/ui/general/Notification';

class AccountsSelectUserForm extends React.Component {
    render() {
        const {
            available_users,
            onSubmit,
            translate,
        } = this.props;

        return (
            <Section title={ translate('resources.accounts.forms.account_select_user') }>
                <Notification>
                    <AccountSearchUserLimit data={ available_users } />
                </Notification>
                <Row>
                    <Table>
                        <TableBody displayRowCheckbox={ false }>
                            <TableRow>
                                <TableRowColumn>{ translate('resources.accounts.select_user.table.email') }</TableRowColumn>
                                <TableRowColumn>{ translate('resources.accounts.select_user.table.name') }</TableRowColumn>
                                <TableRowColumn></TableRowColumn>
                            </TableRow>
                            {
                                available_users.map((user) => {
                                    return (
                                        <TableRow key={ `user_${ user.id }` }>
                                            <TableRowColumn>{ user.email }</TableRowColumn>
                                            <TableRowColumn>{ utils.fullName(user.first_name, user.last_name)}</TableRowColumn>
                                            <TableRowColumn>
                                                <PrimaryButton onClick={ () => {
                                                    return onSubmit(user);
                                                } }/>
                                            </TableRowColumn>
                                        </TableRow>
                                    );
                                })
                            }
                        </TableBody>
                    </Table>
                </Row>
                <Row>
                    <CreateButton basePath={ 'users' } />
                </Row>
            </Section>
        );
    }
}

AccountsSelectUserForm.propTypes = {
    available_users: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
);

export default enhance(AccountsSelectUserForm);



// WEBPACK FOOTER //
// ./src/pages/accounts/create/AccountsSelectUserForm.js